import React, { Component } from "react";

import Volver from "./Volver";
export default class Footer extends Component {
	render() {
		return this.props.history ? (
			<h1
				onClick={e => {
					e.preventDefault();
					this.props.history.goBack();
				}}
			>
				Volver
			</h1>
		) : (
			""
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Volver.js